import { render, staticRenderFns } from "./PetitionLandingPage.vue?vue&type=template&id=3a9f5340&scoped=true&"
import script from "./PetitionLandingPage.vue?vue&type=script&lang=js&"
export * from "./PetitionLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./PetitionLandingPage.vue?vue&type=style&index=0&id=3a9f5340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f5340",
  null
  
)

export default component.exports